// TODO* TODO OA: This is a bit dangerously in common folder, even though it's completely UI stuff. Should be moved.

import { FeatureAccessMessageType, FeatureId } from '../../../../../../../common/iam/access/feature-access/types';

export interface NotAvailableSectionContent {
  accessMessageType: FeatureAccessMessageType;
  elements: NotAvailableCommonElements;
}
export interface NotAvailableSectionContentWithFeatureId extends NotAvailableSectionContent {
  featureId: FeatureId;
}

export enum NotAvailableContentType {
  ICON,
  TITLE,
  INGRESS,
}

export interface NotAvailableIcon {
  svgElement: JSX.Element;
  size?: string;
}

export interface NotAvailableCommonElements {
  icon?: NotAvailableIcon;
  icon_loggedIn?: NotAvailableIcon;
  title: React.ReactNode;
  title_loggedIn?: React.ReactNode;
  ingress: React.ReactNode;
  ingress_loggedIn?: React.ReactNode;
}
